import { useRef } from "react";
import { ChatbotSuggestions } from "../../../utils/constant";
import useSuggestedQuestionsCarousel from "../../../hooks/useSuggestedQuestionsCarousel";

const captionClasses =
    "text-[calc(var(--spacing)*2.5)] leading-none tracking-[0.06em] font-semibold " +
    "text-subtle uppercase mx-0.5 mt-0.5 mb-2";

const carouselWrapClasses = "relative";

const carouselRowClasses =
    "dp-suggest-carousel flex gap-2 mb-2 overflow-x-auto " +
    "[scroll-snap-type:x_mandatory] [-ms-overflow-style:none] [scrollbar-width:none]";

const arrowBase =
    "absolute top-1/2 -translate-y-1/2 z-[2] w-[calc(var(--spacing)*6.5)] h-[calc(var(--spacing)*6.5)] " +
    "rounded-full border border-primary-surface bg-white " +
    "shadow-[0_1px_3px_rgba(16,24,40,0.1)] text-lg leading-none text-body " +
    "cursor-pointer flex items-center justify-center p-0 " +
    "hover:bg-surface-light hover:border-primary-surface";

const arrowLeftClasses = `${arrowBase} left-[-6px]`;
const arrowRightClasses = `${arrowBase} right-[-6px]`;

const pillClasses =
    "appearance-none bg-white border border-primary-surface rounded-lg " +
    "py-2 px-3 text-[calc(var(--spacing)*3.25)] leading-[1.35] text-content " +
    "inline-flex items-center whitespace-nowrap text-left cursor-pointer " +
    "transition-[background,border-color] duration-150 " +
    "hover:bg-surface-light hover:border-primary-surface " +
    "shrink-0 [scroll-snap-align:start]";

const flattenSuggestions = (items) => items.flat();



const ChatSuggestedQuestions = ({ sendMessage }) => {
    const scrollRef = useRef(null);
    const questions = flattenSuggestions(ChatbotSuggestions);
    const { canScrollLeft, canScrollRight, scroll } = useSuggestedQuestionsCarousel(scrollRef);

    return (
        <div>
            <div className={captionClasses}>SUGGESTED QUESTIONS</div>
            <div className={carouselWrapClasses}>
                {canScrollLeft && (
                    <button
                        type="button"
                        className={arrowLeftClasses}
                        onClick={() => scroll('left')}
                        aria-label="Scroll left"
                    >
                        &#8249;
                    </button>
                )}
                <div className={carouselRowClasses} ref={scrollRef}>
                    {questions.map((q, i) => (
                        <button
                            key={`pill-${i}`}
                            type="button"
                            className={pillClasses}
                            onClick={() => sendMessage(q)}
                        >
                            {q}
                        </button>
                    ))}
                </div>
                {canScrollRight && (
                    <button
                        type="button"
                        className={arrowRightClasses}
                        onClick={() => scroll('right')}
                        aria-label="Scroll right"
                    >
                        &#8250;
                    </button>
                )}
            </div>
        </div>
    );
};

export default ChatSuggestedQuestions;
